<template>
  <div class="onboarding-card complete-card">
    <div class="content">
      <div class="success-icon">
        <i class="check circle icon"></i>
      </div>
      <h1 class="header">That's it! You're good to go.</h1>
      <p class="description">
        Get started by adding your customers and creating your first quote.
      </p>
      <p class="description">
        If you get stuck you can find answers in our <router-link to="/help">Help Centre</router-link>, and if a question isn't there, feel free to contact us directly and we will respond within 24 hours.
      </p>
      <button
        type="button"
        class="ui primary button start-button"
        :class="{ loading: completing }"
        :disabled="completing"
        @click="finish"
      >
        Start Using Smardie
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'OnboardingComplete',
  data() {
    return {
      completing: false
    };
  },
  methods: {
    finish() {
      this.completing = true;
      const plan = this.$route.query.plan;
      const body = (plan === 'free' || plan === 'trial') ? { plan: 'free' } : {};
      axios.post('/api/auth/onboarding/complete', body).then(() => {
        return axios.get('/api/auth/user');
      }).then((res) => {
        if (res.data) {
          if (res.data.user) this.$store.commit('user/setUserProfile', res.data.user);
          if (res.data.subscription) this.$store.commit('user/setUserSubscription', res.data.subscription);
        }
        this.$router.push('/').catch(() => {});
      }).catch((err) => {
        this.errorNotification((err.response && err.response.data && err.response.data.error) || 'Something went wrong. Please try again.');
      }).finally(() => {
        this.completing = false;
      });
    }
  }
};
</script>

<style scoped>
.complete-card {
  text-align: center;
  max-width: 560px;
  margin: 0 auto;
  padding-top: 2.5rem;
}
.success-icon {
  margin-bottom: 1rem;
}
.success-icon .icon {
  font-size: 4rem;
  color: var(--color-success);
}
.complete-card .header {
  margin-top: 0;
}
.description {
  color: var(--color-mid-grey);
  margin-bottom: 1rem;
}
.start-button {
  margin-top: 1.5rem;
}
</style>
